import Cookies from 'universal-cookie';

const GLOBAL_COOKIES = new Cookies();
const SIGNED_IN_LD_USER_KEY_COOKIE_NAME = 'ld_user_key';

/**
 * getLaunchDarklyUserKeyCookieValue is here for the rest of the lib/flags package
 * and it's unlikely you want to use it.
 *
 * getLaunchDarklyUserKeyCookieValue returns the value of the cookie our backend
 * sets to identify the current user to LaunchDarkly.
 */
export function getLaunchDarklyUserKeyCookieValue(): string | undefined {
  return GLOBAL_COOKIES.get<string>(SIGNED_IN_LD_USER_KEY_COOKIE_NAME, { doNotParse: true });
}
